export function sumarMinutos(horaStr, minutos) {
  const [h, m] = horaStr.split(":").map(Number);
  const total = h * 60 + m + minutos;
  const mod = ((total % 1440) + 1440) % 1440;
  const horas = Math.floor(mod / 60);
  const mins = mod % 60;
  return `${horas.toString().padStart(2, "0")}:${mins
    .toString()
    .padStart(2, "0")}`;
}

export function rangosSeSolapan(inicio1, fin1, inicio2, fin2) {
  const [h1, m1] = inicio1.split(":").map(Number);
  const [h2, m2] = fin1.split(":").map(Number);
  const [h3, m3] = inicio2.split(":").map(Number);
  const [h4, m4] = fin2.split(":").map(Number);

  const t1 = h1 * 60 + m1;
  const t2 = h2 * 60 + m2;
  const t3 = h3 * 60 + m3;
  const t4 = h4 * 60 + m4;

  return t1 < t4 && t3 < t2;
}

export function generarTimeSlots(
  inicio,
  fin,
  duracion,
  fechaBase,
  permitirPasados = false
) {
  if (!inicio || !fin) return [];
  const duracionSegura = Number(duracion) || 0;
  if (duracionSegura <= 0) return [];
  const toMinutes = (time) => {
    const [h, m] = time.split(":").map(Number);
    return h * 60 + m;
  };
  const toTime = (mins) => {
    const h = Math.floor(mins / 60);
    const m = mins % 60;
    return `${h.toString().padStart(2, "0")}:${m.toString().padStart(2, "0")}`;
  };

  const slots = [];
  const startMinutes = toMinutes(inicio);
  const endMinutes = toMinutes(fin);
  const hoy = new Date();
  const hoyISO = hoy.toISOString().split("T")[0];
  const mismoDia = fechaBase === hoyISO;
  const ahoraMinutos = hoy.getHours() * 60 + hoy.getMinutes();

  for (
    let cursor = startMinutes;
    cursor + duracionSegura <= endMinutes;
    cursor += duracionSegura
  ) {
    if (permitirPasados || !mismoDia || cursor > ahoraMinutos) {
      slots.push(toTime(cursor));
    } else {
      console.log("⚠️ Slot descartado por estar en el pasado:", toTime(cursor));
    }
  }

  console.log("✅ Slots generados:", slots);
  return slots;
}

export function expandirBloquesRepetibles(bloques, semanas = 6) {
    const clones = [];
  
    for (const bloque of bloques) {
      if (!bloque.repetir || !bloque.start || !bloque.end) {
        clones.push(bloque); // mantener bloque original
        continue;
      }
  
      const startOriginal = new Date(bloque.start);
      const endOriginal = new Date(bloque.end);
      const excepciones = bloque.excepciones || [];
  
      for (let i = 0; i <= semanas; i++) {
        // Clona el mismo día de la semana N semanas adelante
        const startClone = new Date(startOriginal);
        const endClone = new Date(endOriginal);
  
        startClone.setDate(startOriginal.getDate() + i * 7);
        endClone.setDate(endOriginal.getDate() + i * 7);
  
        const fechaStr = startClone.toISOString().split("T")[0];
  
        if (excepciones.includes(fechaStr)) continue;
  
        clones.push({
          ...bloque,
          start: startClone.toISOString(),
          end: endClone.toISOString(),
          repetir: false,
          esClon: i !== 0,
          originalId: bloque.id || null,
        });
      }
    }
  
    return clones;
  }
  
